import React from 'react';
import { withStyles } from '@mui/styles';

const styles = {
  loader: {
    width: '17px',
    height: '17px',
    flexShrink: '0',
    borderRadius: '50%',
    background: 'transparent',
    border: '3px solid #d8d8d8',
    borderTop: '3px solid #3f51b5',
    animation: '$spin 1s linear infinite;',
  },
  '@keyframes spin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
};

export default withStyles(styles)(({ classes, style }) => <div style={style} className={classes.loader} />);
